/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// Size Chart Toggle Handler
// Works with any <size-chart-custom> elements on the page

(function() {
  'use strict';
  
  function initSizeChart(container) {
    const toggle = container.querySelector('.unit-toggle');
    const labels = container.querySelectorAll('.sg-toggle-label');
    const measurements = container.querySelectorAll('.measurement');
    
    if (!toggle || !measurements.length) return;
    
    toggle.addEventListener('change', function() {
      const isCm = this.checked;
      
      // Update Labels
      labels.forEach(label => {
        const unit = label.getAttribute('data-unit');
        if (unit === 'cm') {
          label.classList.toggle('active', isCm);
          label.classList.toggle('inactive', !isCm);
        } else if (unit === 'inch') {
          label.classList.toggle('active', !isCm);
          label.classList.toggle('inactive', isCm);
        }
      });
      
      // Update Measurements
      measurements.forEach(td => {
        td.textContent = isCm ? td.getAttribute('data-cm') : td.getAttribute('data-inch');
      });
    });
  }
  
  // Initialize all size charts on the page
  function initAllSizeCharts() {
    const charts = document.querySelectorAll('size-chart-custom');
    charts.forEach(chart => initSizeChart(chart));
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSizeCharts);
  } else {
    initAllSizeCharts();
  }
  
  // Also support dynamic insertion
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.tagName && node.tagName.toLowerCase() === 'size-chart-custom') {
              initSizeChart(node);
            }
            // Also check children
            const charts = node.querySelectorAll && node.querySelectorAll('size-chart-custom');
            if (charts) {
              charts.forEach(chart => initSizeChart(chart));
            }
          }
        });
      });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();